// utility/updateCustomer.js
import ENV from "../env";
import getAuthHeaders from "./authHeaders";

const updateCustomer = async (
  customerId,
  note,
  date,
  stat,
  action,
  project,
  title,
  selectedShowroom,
  vendeur,
  crmContactId, 
  crmDealId
) => {
  console.log(vendeur);
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${ENV.firebaseApiUrl}/customer/update`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      customerId,
      note,
      date,
      stat,
      action,
      project,
      title,
      showroom: selectedShowroom,
      vendeur,
      contactId: crmContactId, 
      dealId: crmDealId,
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Create customer failed: " + resData.message);
  }

  return resData.success;
};

export default updateCustomer;